import { useState, useEffect, Fragment, useRef } from "react";

import "./style.css";

import { FlickrData, RegisterModalObserver, ChangeModalState } from "Interfaces/ModalInterface.js";

function FlickrModal() {

    const [showGallery, setShowGallery] = useState(false);
    const [galleryWidth, setGalleryWidth] = useState("320px");
    const [galleryURL, setGalleryURL] = useState("");

    const loadingDiv = useRef();

    function HandleGallerySize(){
        let aspectRatio = window.innerWidth / window.innerHeight;
        let maxWidth = Math.min(window.innerWidth - 20, 900);
        let maxHeight = window.innerHeight - 110;

        let WidthBasedHeight = Math.min((maxHeight * 16) / 9, 900);
  
        if (aspectRatio > 1) {
            setGalleryWidth(WidthBasedHeight + "px");
        } else {
            setGalleryWidth(maxWidth + "px");
        }            
    }

    useEffect(() => {
        RegisterModalObserver("FlickrModal", (state) => {
            HandleGallerySize();
            setShowGallery(state);             
        });

        HandleGallerySize();

        window.addEventListener("resize", HandleGallerySize);
    }, []);

    useEffect(() => {
        if(showGallery){
            setGalleryURL(FlickrData.url);
            setTimeout(() =>{
                if(loadingDiv.current){
                    loadingDiv.current.innerHTML="Carregando.";
                }
            }, 600);
            setTimeout(() =>{
                if(loadingDiv.current){
                    loadingDiv.current.innerHTML="Carregando..";
                }
            }, 1200);
            setTimeout(() =>{
                if(loadingDiv.current){
                    loadingDiv.current.innerHTML="Carregando...";
                }
            }, 1800);
            setTimeout(() =>{
                if(loadingDiv.current){
                    loadingDiv.current.style.display="none";
                }
            }, 2500);
        }else{
            setGalleryURL("");
        }
      
    }, [showGallery]);

    return (
        <Fragment>
            {showGallery ? 
                <div className="flickrModal" >
                  <div className="flickrModalBG" onClick={() => {ChangeModalState("FlickrModal", false); FlickrData.url = ""}} >
                  </div>
                  <div className="flickrModalContainer" style={{maxWidth: galleryWidth}}>
                    <div className="flickrModalHeader">
                        <p></p>
                        <button
                            onClick={() => {ChangeModalState("FlickrModal", false); FlickrData.url = ""}}
                        >
                            <svg
                                width="72"
                                height="13"
                                viewBox="0 0 72 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2.456 0.912C3.02133 0.912 3.59733 0.917333 4.184 0.927999C4.78133 0.927999 5.36267 0.944 5.928 0.976C6.504 0.997333 7.03733 1.03467 7.528 1.088L7.4 2.848H3.4C3.112 2.848 2.89333 2.91733 2.744 3.056C2.59467 3.19467 2.52 3.39733 2.52 3.664V12H0.072V3.168C0.072 2.48533 0.290667 1.94133 0.728 1.536C1.16533 1.12 1.74133 0.912 2.456 0.912ZM0.36 5.584H6.808V7.312H0.36V5.584ZM11.2823 0.912C11.8796 0.912 12.4823 0.917333 13.0903 0.927999C13.6983 0.927999 14.2956 0.938666 14.8823 0.959999C15.4689 0.981333 16.0183 1.01867 16.5303 1.072L16.4183 2.848H12.1783C11.9116 2.848 11.7089 2.91733 11.5703 3.056C11.4423 3.19467 11.3783 3.39733 11.3783 3.664V9.296C11.3783 9.56267 11.4423 9.76533 11.5703 9.904C11.7089 10.0427 11.9116 10.112 12.1783 10.112H16.4183L16.5303 11.888C16.0183 11.9307 15.4689 11.968 14.8823 12C14.2956 12.0213 13.6983 12.032 13.0903 12.032C12.4823 12.0427 11.8796 12.048 11.2823 12.048C10.5783 12.048 10.0076 11.8453 9.57025 11.44C9.14358 11.024 8.93025 10.4853 8.93025 9.824V3.136C8.93025 2.464 9.14358 1.92533 9.57025 1.52C10.0076 1.11467 10.5783 0.912 11.2823 0.912ZM9.21825 5.392H15.8263V7.12H9.21825V5.392ZM22.4709 0.768C22.9935 0.768 23.4362 0.783999 23.7989 0.815999C24.1722 0.837333 24.5135 0.874666 24.8229 0.927999C25.1322 0.981333 25.4522 1.056 25.7829 1.152L25.5909 2.944C25.2389 2.92267 24.9135 2.90667 24.6149 2.896C24.3269 2.88533 24.0122 2.88 23.6709 2.88C23.3402 2.86933 22.9402 2.864 22.4709 2.864C21.9269 2.864 21.5002 2.97067 21.1909 3.184C20.8922 3.39733 20.6789 3.77067 20.5509 4.304C20.4229 4.82667 20.3589 5.552 20.3589 6.48C20.3589 7.408 20.4229 8.13867 20.5509 8.672C20.6789 9.19467 20.8922 9.56267 21.1909 9.776C21.5002 9.98933 21.9269 10.096 22.4709 10.096C23.2069 10.096 23.8255 10.0853 24.3269 10.064C24.8282 10.0427 25.3242 10.0053 25.8149 9.952L26.0229 11.744C25.5109 11.904 24.9882 12.016 24.4549 12.08C23.9215 12.1547 23.2602 12.192 22.4709 12.192C21.3295 12.192 20.4122 12.0107 19.7189 11.648C19.0362 11.2747 18.5402 10.672 18.2309 9.84C17.9322 9.008 17.7829 7.888 17.7829 6.48C17.7829 5.072 17.9322 3.952 18.2309 3.12C18.5402 2.288 19.0362 1.69067 19.7189 1.328C20.4122 0.954666 21.3295 0.768 22.4709 0.768ZM30.0211 0.959999V12H27.5731V0.959999H30.0211ZM34.1171 5.2V7.04H29.8931V5.2H34.1171ZM36.3891 0.959999V12H33.9411V0.959999H36.3891ZM43.8996 0.959999C44.1023 0.959999 44.2783 1.01867 44.4276 1.136C44.5876 1.25333 44.6943 1.408 44.7476 1.6L47.9476 12H45.4516L43.1956 3.888C43.153 3.70667 43.1103 3.52533 43.0676 3.344C43.025 3.152 42.9876 2.97067 42.9556 2.8H42.5236C42.4916 2.97067 42.4543 3.152 42.4116 3.344C42.3796 3.52533 42.337 3.70667 42.2836 3.888L40.0276 12H37.5156L40.7316 1.6C40.785 1.408 40.8863 1.25333 41.0356 1.136C41.1956 1.01867 41.377 0.959999 41.5796 0.959999H43.8996ZM45.5956 7.248V9.088H39.8676V7.248H45.5956ZM53.3288 0.799999C54.2994 0.799999 55.0834 0.901333 55.6808 1.104C56.2888 1.296 56.7314 1.632 57.0087 2.112C57.2968 2.58133 57.4408 3.23733 57.4408 4.08C57.4408 4.592 57.3714 5.04533 57.2328 5.44C57.1048 5.824 56.8861 6.13333 56.5768 6.368C56.2674 6.60267 55.8461 6.752 55.3128 6.816V6.896C55.5048 6.928 55.7021 7.00267 55.9048 7.12C56.1181 7.23733 56.3154 7.41333 56.4968 7.648C56.6781 7.872 56.8114 8.176 56.8968 8.56L57.8568 12H55.2808L54.4328 8.64C54.3368 8.27733 54.1928 8.02667 54.0008 7.888C53.8194 7.74933 53.5634 7.68 53.2328 7.68C52.5074 7.68 51.8941 7.68 51.3928 7.68C50.9021 7.66933 50.4861 7.65867 50.1448 7.648C49.8141 7.63733 49.5154 7.62667 49.2488 7.616L49.2968 5.84H53.2808C53.7074 5.84 54.0434 5.79733 54.2888 5.712C54.5448 5.616 54.7208 5.45067 54.8168 5.216C54.9234 4.98133 54.9768 4.656 54.9768 4.24C54.9768 3.81333 54.9234 3.488 54.8168 3.264C54.7208 3.02933 54.5448 2.86933 54.2888 2.784C54.0434 2.688 53.7074 2.64 53.2808 2.64C52.2781 2.64 51.4301 2.64533 50.7368 2.656C50.0434 2.66667 49.5688 2.68267 49.3128 2.704L49.0728 0.959999C49.5208 0.906666 49.9421 0.869333 50.3368 0.848C50.7314 0.826666 51.1634 0.815999 51.6328 0.815999C52.1021 0.805333 52.6674 0.799999 53.3288 0.799999ZM51.4888 0.959999V12H49.0728V0.959999H51.4888ZM71.7016 0.959999L68.9816 6.336L71.9096 12H69.4136L66.6616 6.336L69.2216 0.959999H71.7016ZM64.6136 0.959999L67.1736 6.336L64.4216 12H61.9256L64.8376 6.336L62.1336 0.959999H64.6136ZM68.1016 5.552V7.056H65.5896V5.552H68.1016Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="ifameFlickr">
                        <div className="loading" ref={loadingDiv}>Carregando</div>
                        <iframe                            
                            src={"https://flickrembed.com/cms_embed.php?source=flickr&layout=responsive&input="+galleryURL+"&sort=0&by=album&theme=default&scale=fill&speed=5000&limit=10&skin=default&autoplay=true"}                           
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                    </div>
                </div>
            : null }
        </Fragment>
    );
}

export default FlickrModal;
